var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.7143 0.0) scale(1.714286)"
  }, /*#__PURE__*/React.createElement("defs", null), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.05 0.28C7.69 -0.1 4.3 -0.1 0.94 0.28C0.75 0.3 0.57 0.37 0.42 0.49C0.27 0.61 0.15 0.76 0.07 0.94C0 1.12 -0.02 1.32 0.01 1.51C0.03 1.7 0.11 1.88 0.23 2.03L3.15 5.68C3.99 6.73 4.45 8.03 4.45 9.38L4.45 11.84C4.45 11.93 4.47 12.02 4.51 12.11C4.55 12.19 4.61 12.26 4.68 12.31L6.83 13.91C6.9 13.96 6.98 13.99 7.06 13.99C7.14 14 7.22 13.98 7.3 13.95C7.37 13.91 7.43 13.85 7.48 13.78C7.52 13.71 7.54 13.62 7.54 13.54L7.54 9.38C7.55 8.03 8 6.73 8.84 5.68L11.76 2.03C11.88 1.88 11.96 1.7 11.98 1.5C12.01 1.31 11.99 1.12 11.92 0.94C11.84 0.76 11.72 0.61 11.57 0.49C11.42 0.37 11.24 0.3 11.05 0.28Z",
    fill: "currentColor",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filterIcon.bcb8c39f6dee4590ae9b148ff33d8f73.svg";
export { ForwardRef as ReactComponent };